export default __webpack_public_path__ + "static/media/status_online.afc1c932.svg";